import React from 'react';
import { Layout } from '../components/layout/Layout';
import { Button } from '../components/ui/Button';
import { Youtube, Facebook, Radio, Smartphone, Monitor, Play, ExternalLink } from 'lucide-react';
import { motion } from 'framer-motion';
export function LiveStreamPage() {
  return <Layout data-id="element-1027">
      {/* Header */}
      <div className="bg-[#0A1F44] pt-44 md:pt-48 pb-20 text-center text-white relative overflow-hidden" data-id="element-1028">
        <div className="absolute inset-0 opacity-20" data-id="element-1029">
          <img src="https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80" alt="Background" className="w-full h-full object-cover" data-id="element-1030" />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A1F44] via-[#0A1F44]/70 to-[#0A1F44]" data-id="element-1031" />
        <div className="container-custom relative z-10" data-id="element-1032">
          <div className="inline-flex items-center gap-2 bg-red-600 text-white px-4 py-1.5 rounded-full text-sm font-medium mb-6" data-id="element-1033">
            <span className="w-2 h-2 bg-white rounded-full animate-pulse" data-id="element-1034" />
            Live Every Sunday
          </div>
          <h1 className="text-4xl md:text-6xl font-serif font-bold mb-4" data-id="element-1035">
            Live Stream
          </h1>
          <p className="text-xl text-white/80 max-w-2xl mx-auto" data-id="element-1036">
            Join us online for worship, wherever you are.
          </p>
        </div>
      </div>

      {/* Main Stream Section */}
      <section className="py-12 md:py-20 bg-white" data-id="element-1037">
        <div className="container-custom" data-id="element-1038">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12" data-id="element-1039">
            {/* Video Player */}
            <div className="lg:col-span-2" data-id="element-1040">
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} className="bg-black rounded-2xl overflow-hidden shadow-2xl aspect-video relative" data-id="element-1041">
                {/* Placeholder for actual video player */}
                <div className="absolute inset-0 flex flex-col items-center justify-center text-white p-8 text-center" data-id="element-1042">
                  <Youtube className="w-16 h-16 text-red-600 mb-4" data-id="element-1043" />
                  <h3 className="text-2xl font-bold mb-2" data-id="element-1044">
                    Sunday Service Broadcast
                  </h3>
                  <p className="text-gray-400 mb-6" data-id="element-1045">
                    Our next live stream begins Sunday at 10:00 AM EST
                  </p>
                  <Button variant="primary" leftIcon={<Play className="w-4 h-4" data-id="element-1047" />} data-id="element-1046">
                    Watch Latest Sermon
                  </Button>
                </div>
              </motion.div>

              {/* Stream Info */}
              <div className="mt-8 bg-gray-50 p-6 rounded-xl border border-gray-100" data-id="element-1048">
                <h3 className="text-xl font-bold text-[#0A1F44] mb-2" data-id="element-1049">
                  Experiencing issues?
                </h3>
                <p className="text-gray-600 text-sm mb-4" data-id="element-1050">
                  If the video player above isn't working, you can also watch
                  our live stream directly on our social media platforms.
                </p>
                <div className="flex flex-wrap gap-4" data-id="element-1051">
                  <a href="https://youtube.com/@householdchurch" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm font-medium text-red-600 hover:text-red-700 transition-colors" data-id="element-1052">
                    <Youtube className="w-4 h-4" data-id="element-1053" /> Watch on YouTube
                    <ExternalLink className="w-3 h-3" data-id="element-1054" />
                  </a>
                  <a href="https://facebook.com/householdchurch" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm font-medium text-blue-600 hover:text-blue-700 transition-colors" data-id="element-1055">
                    <Facebook className="w-4 h-4" data-id="element-1056" /> Watch on Facebook
                    <ExternalLink className="w-3 h-3" data-id="element-1057" />
                  </a>
                </div>
              </div>
            </div>

            {/* Ways to Watch */}
            <motion.div initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.2
          }} className="flex flex-col justify-center" data-id="element-1058">
              <span className="text-[#fc0719] text-sm font-bold tracking-widest uppercase mb-4 block" data-id="element-1059">
                Other Platforms
              </span>
              <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#0A1F44] mb-6" data-id="element-1060">
                Watch & Listen
                <br data-id="element-1061" />
                <span className="text-[#0A1F44]" data-id="element-1062">On The Way</span>
              </h2>
              <p className="text-gray-600 mb-8 text-lg leading-relaxed" data-id="element-1063">
                Stay connected and join our online services via Facebook and
                YouTube. Never miss a powerful message - watch live or catch up
                on past sermons anytime, anywhere.
              </p>

              {/* Stream Buttons */}
              <div className="flex flex-wrap gap-4" data-id="element-1064">
                <a href="https://youtube.com/@householdchurch" target="_blank" rel="noopener noreferrer" data-id="element-1065">
                  <Button variant="secondary" size="lg" className="bg-[#0A1F44] hover:bg-[#081833]" leftIcon={<Youtube className="w-5 h-5" data-id="element-1067" />} data-id="element-1066">
                    YouTube
                  </Button>
                </a>
                <a href="https://facebook.com/householdchurch" target="_blank" rel="noopener noreferrer" data-id="element-1068">
                  <Button variant="outline" size="lg" className="border-[#1877F2] text-[#1877F2] hover:bg-[#1877F2] hover:text-white" leftIcon={<Facebook className="w-5 h-5" data-id="element-1070" />} data-id="element-1069">
                    Facebook
                  </Button>
                </a>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Service Times Reminder */}
      <section className="py-16 bg-[#0A1F44]" data-id="element-1071">
        <div className="container-custom" data-id="element-1072">
          <div className="max-w-3xl mx-auto text-center" data-id="element-1073">
            <Radio className="w-10 h-10 text-[#fc0719] mx-auto mb-6" data-id="element-1074" />
            <h3 className="text-2xl font-serif font-bold text-white mb-4" data-id="element-1075">
              When to Tune In
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8" data-id="element-1076">
              <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl" data-id="element-1077">
                <h4 className="font-bold text-white mb-2" data-id="element-1078">Sunday Service</h4>
                <p className="text-white/80" data-id="element-1079">10:00 AM EST</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl" data-id="element-1080">
                <h4 className="font-bold text-white mb-2" data-id="element-1081">Impact Wednesday</h4>
                <p className="text-white/80" data-id="element-1082">7:00 PM EST</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl" data-id="element-1083">
                <h4 className="font-bold text-white mb-2" data-id="element-1084">Deep Dive</h4>
                <p className="text-white/80" data-id="element-1085">Sunday 9:00 AM EST</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Devices Section */}
      <section className="py-20 bg-gray-50" data-id="element-1086">
        <div className="container-custom" data-id="element-1087">
          <div className="text-center max-w-2xl mx-auto mb-12" data-id="element-1088">
            <h2 className="text-3xl font-serif font-bold text-[#0A1F44] mb-4" data-id="element-1089">
              Watch on Any Device
            </h2>
            <p className="text-gray-600" data-id="element-1090">
              Our stream is optimized for all your devices so you can worship
              wherever you are.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1091">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-white p-8 rounded-2xl shadow-lg text-center" data-id="element-1092">
              <Radio className="w-10 h-10 text-[#fc0719] mx-auto mb-6" data-id="element-1093" />
              <h3 className="text-xl font-bold mb-2" data-id="element-1094">Smart TV</h3>
              <p className="text-white/60" data-id="element-1095">
                Watch on YouTube or Facebook via your Smart TV app.
              </p>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-white p-8 rounded-2xl shadow-lg text-center" data-id="element-1096">
              <Smartphone className="w-12 h-12 text-[#fc0719] mx-auto mb-4" data-id="element-1097" />
              <h3 className="text-xl font-bold mb-2" data-id="element-1098">Mobile App</h3>
              <p className="text-white/60" data-id="element-1099">
                Download our app for the best mobile viewing experience.
              </p>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-white p-8 rounded-2xl shadow-lg text-center" data-id="element-1100">
              <Radio className="w-12 h-12 text-[#fc0719] mx-auto mb-4" data-id="element-1101" />
              <h3 className="text-xl font-bold mb-2" data-id="element-1102">Radio</h3>
              <p className="text-white/60" data-id="element-1103">
                Listen to our audio-only stream for lower data usage.
              </p>
            </motion.div>
          </div>
        </div>
      </section>
    </Layout>;
}